export default {
  props: {
    stepData: {
      default: () => ({
        name: '',
        button_name: '',
        url: '',
        header: '',
        description: '',
      }),
      type: Object,
    },
  },
  data() {
    return {

    }
  },
}
